module.exports = __webpack_public_path__ + "static/media/PM122.5ab84d39.png";